
/**
 * Reads the full table dataset from Handsontable, including rows hidden by column filters.
 * Edits made while filtered are kept — no filter clear or re-render required.
 * @param {object} hot Handsontable instance
 * @param {string[]} tableHeaders Column header names
 * @returns {object[]}
 */
const readFullTableData = (hot, tableHeaders) => {
    const sourceData = hot.getSourceData();

    if (Array.isArray(sourceData) && sourceData.length > 0) {
        const firstRow = sourceData[0];
        if (firstRow && typeof firstRow === "object" && !Array.isArray(firstRow)) {
            return sourceData.map((row) => ({ ...row }));
        }
    }

    const sourceRows =
        typeof hot.getSourceDataArray === "function"
            ? hot.getSourceDataArray()
            : sourceData;

    if (!Array.isArray(sourceRows)) {
        return [];
    }

    return sourceRows.map((row) => {
        const obj = {};
        tableHeaders.forEach((key, index) => {
            obj[key] = row[index];
        });
        return obj;
    });
};

/**
 * @name RetriveDataFromTable
 * @param {React.RefObject} _TableRef : Reference to Table
 *
 * Uses getSourceData() so all rows are included even when column filters are active.
 *
 * @returns [objects]
 */
const RetriveDataFromTable = (_TableRef, options = {}) => {
    const { includeEmptyRows = false } = options;

    if (_TableRef?.current?.hotInstance) {
        const hot = _TableRef.current.hotInstance;
        const tableHeaders = hot.getColHeader();
        let data = readFullTableData(hot, tableHeaders);

        if (!includeEmptyRows) {
            data = data.filter(
                (obj) =>
                    obj["RingNo"] !== null &&
                    obj["RingNo"] !== "" &&
                    obj["RingNo"] !== undefined
            );
        }
        return data;
    }
};

export { RetriveDataFromTable, readFullTableData };
